<template>
  <div>
    <va-card :class="{'closed': !expanded}">
      <template slot="header">
        <div class="d-flex align-items-center justify-content-between w-100">
          <h5 class="card-title">{{ $t('accounts.hearing_tests') }}</h5>
          <span v-if="expandable" @click.prevent="expanded = !expanded">
            <va-icon class="clickable" :name="expandIconClass" color="success"/>
          </span>
        </div>
      </template>

      <div v-show="expanded">
        <v-server-table
          :columns="tableColumns"
          :options="tableOptions"
          @row-click="selectHearingTest"
          ref="hearingTestsTable">
            <span slot="created_at" class="no-break" slot-scope="{row}">{{ row.created_at | localTime }}</span>

            <span slot="hl_right" class="no-break" slot-scope="props">{{ props.row.hl_right}} dB HL</span>

            <span slot="hl_left" class="no-break" slot-scope="props">{{ props.row.hl_left}} dB HL</span>

        </v-server-table>
      </div>
    </va-card>

    <hearing-test-modal v-if="selectedHearingTest" :service="service" :hearingTest="selectedHearingTest" @closeModal="selectedHearingTest = null"></hearing-test-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import HearingTestModal from './HearingTestModal'
import TableQueryMixin from '@/mixins/TableQueryMixin'

export default {
  props: {
    account: {
      type: Object,
      required: true
    },
    expandable: {
      type: Boolean,
      required: false,
      default: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  mixins: [
    TableQueryMixin
  ],
  components: {
    HearingTestModal
  },
  computed: {
    expandIconClass: function () {
      return this.expanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
    }
  },
  data: function () {
    return {
      isOpen: false,
      expanded: true,
      selectedHearingTest: null,
      queryUrl: `${this.service.url}/admin/users/${this.account.id}/hearing-tests`,
      tableColumns: [
        'created_at',
        'hl_left',
        'hl_right',
        'device_brand',
        'headphoneType'
      ],
      tableOptions: {
        filterable: false,
        sortable: ['created_at', 'hl_left', 'hl_right'],
        headings: {
          created_at: this.$t('tables.columns.created_at'),
          device_brand: this.$t('tables.columns.device_brand'),
          headphoneType: this.$t('tables.columns.headphone_type'),
          hl_left: this.$t('clinical.hearing_test.hl_left'),
          hl_right: this.$t('clinical.hearing_test.hl_right'),
        },
        columnsDropdown: false
      },
    }
  },
  methods: {
    selectHearingTest: function (event) {
      Vue.nextTick(() => {
        this.selectedHearingTest = event.row
        // this.showNotifyEmailModal = true
      })
    }
  }
}
</script>
